import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface NewsItem {
  id: string;
  date: string;
  title: string;
  content: string;
  createdAt: number;
}

const NewsSection = () => {
  const [newsList, setNewsList] = useState<NewsItem[]>([]);

  useEffect(() => {
    const stored = localStorage.getItem('heartFailureNews');
    if (stored) {
      const parsed = JSON.parse(stored);
      const sorted = parsed.sort((a: NewsItem, b: NewsItem) => b.createdAt - a.createdAt);
      setNewsList(sorted.slice(0, 5));
    }
  }, []);

  if (newsList.length === 0) {
    return null;
  }

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between mb-12">
          <div>
            <p className="text-gray-500 text-sm font-medium mb-3 uppercase tracking-wider">News</p>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900">お知らせ</h2>
          </div>
          <Link
            to="/news"
            className="inline-flex items-center gap-2 text-primary-500 hover:text-primary-600 font-medium text-sm cursor-pointer transition-colors"
          >
            すべて見る
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="space-y-4">
          {newsList.map((news) => (
            <Link
              key={news.id}
              to="/news"
              className="block bg-gray-50 rounded-2xl p-6 hover:bg-gray-100 transition-all duration-300 group cursor-pointer"
            >
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0">
                  <span className="inline-block px-4 py-2 bg-primary-100 text-primary-700 text-sm font-medium rounded-full whitespace-nowrap">
                    {news.date}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-primary-600 transition-colors">
                    {news.title}
                  </h3>
                </div>
                <div className="flex-shrink-0">
                  <i className="ri-arrow-right-line text-2xl text-gray-400 group-hover:text-primary-500 group-hover:translate-x-1 transition-all duration-300"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
